// add new package
let packageIndex = 1;
        $(document).ready(function () {
            $('#addPackage').on('click', function (e) {
                e.preventDefault(); // Prevent form submission or default behavior
                
                // HTML content to append
                const newPackage = `
                  <div class="d-flex flex-wrap gap-1 my-4 package-item">
                      <div class="form-group flex-1">
                          <label>Package Type:</label>
                          <input type="text" name="packages[${packageIndex}][package_type]" placeholder="Package Type" class="form-control" required>
                      </div>
                      <div class="form-group flex-1">
                          <label>Weight:</label>
                          <input type="number" name="packages[${packageIndex}][weight]" placeholder="Weight" class="form-control" required>
                      </div>
                      <div class="form-group flex-1">
                          <label>Length (CM):</label>
                          <input type="number" name="packages[${packageIndex}][length]" placeholder="Length (CM)" class="form-control" required>
                      </div>
                      <div class="form-group flex-1">
                          <label>Width (CM):</label>
                          <input type="number" name="packages[${packageIndex}][width]" placeholder="Width (CM)" class="form-control" required>
                      </div>
                      <div class="form-group flex-1">
                          <label>Height (CM):</label>
                          <input type="number" name="packages[${packageIndex}][height]" placeholder="Height (CM)" class="form-control" required>
                      </div>
                      <div class="form-group flex-1">
                          <label>Stackable:</label>
                          <select name="packages[${packageIndex}][stackable]" class="form-control" required>
                              <option value="yes">Yes</option>
                              <option value="No">No</option>
                          </select>
                      </div>
                      <div class="form-group flex-1">
                          <label>Quantity:</label>
                          <input type="number" name="packages[${packageIndex}][quantity]" placeholder="Quantity" class="form-control" required>
                      </div>
                  </div>`;
                
                // Append the new package to the packages container
                $('.packages').append(newPackage);
                setFormHeight();
                packageIndex++;
            });
        });

    $(document).ready(function () {
        // Selectors for the total weight and total quantity spans

        // Function to calculate totals
        function calculateTotals() {
            let totalWeight = 0;
            let totalQuantity = 0;

            // Loop through each package item
            $(".package-item").each(function () {
                const weight = parseFloat($(this).find('input[name*="[weight]"]').val()) || 0;
                const quantity = parseInt($(this).find('input[name*="[quantity]"]').val()) || 0;

                totalWeight += weight;
                totalQuantity += quantity;
            });

            // Update the spans with the calculated values
            $("#total_weight").text(totalWeight.toFixed(2)); // Up to 2 decimal places
            $("#total_quantity").text(totalQuantity);
        }

        // Attach event listeners to weight and quantity inputs
        $(".packages").on("input", 'input[name*="[weight]"], input[name*="[quantity]"]', function () {
            calculateTotals();
        });

        // Initial calculation on page load
        calculateTotals();
    });

// delivery to UK form

$(document).ready(function () {
  const DOMstrings = {
    stepsBtnClass: 'multisteps-form__progress-btn',
    stepsBtns: $('.multisteps-form__progress-btn'),
    stepsBar: $('.multisteps-form__progress'),
    stepsForm: $('.multisteps-form__form'),
    stepsFormTextareas: $('.multisteps-form__textarea'),
    stepFormPanelClass: 'multisteps-form__panel',
    stepFormPanels: $('.multisteps-form__panel'),
    stepPrevBtnClass: 'js-btn-prev',
    stepNextBtnClass: 'js-btn-next',
    requiredFieldsSelector: 'input[required], textarea[required]'
  };

  const removeClasses = (elemSet, className) => {
    elemSet.removeClass(className);
  };

  const findParent = (elem, parentClass) => {
    return elem.closest(`.${parentClass}`);
  };

  const getActiveStep = elem => {
    return DOMstrings.stepsBtns.index(elem);
  };

  const setActiveStep = activeStepNum => {
    removeClasses(DOMstrings.stepsBtns, 'js-active');
    DOMstrings.stepsBtns.each(function (index) {
      if (index <= activeStepNum) {
        $(this).addClass('js-active');
      }
    });
  };

  const getActivePanel = () => {
    return DOMstrings.stepFormPanels.filter('.js-active').first();
  };

  const setActivePanel = activePanelNum => {
    removeClasses(DOMstrings.stepFormPanels, 'js-active');
    DOMstrings.stepFormPanels.each(function (index) {
      if (index === activePanelNum) {
        $(this).addClass('js-active');
        setFormHeight($(this));
      }
    });
  };

  const formHeight = activePanel => {
    const activePanelHeight = activePanel.outerHeight();
    DOMstrings.stepsForm.css('height', `${activePanelHeight}px`);
  };

  const setFormHeight = () => {
    const activePanel = getActivePanel();
    formHeight(activePanel);
  };

  const validateCurrentPanel = () => {
    const activePanel = getActivePanel();
    const requiredFields = activePanel.find(DOMstrings.requiredFieldsSelector);
    let isValid = true;

    requiredFields.each(function () {
      if (!$(this).val().trim()) {
        isValid = false;
        $(this).addClass('invalid'); // Add a class for invalid fields (optional styling)
      } else {
        $(this).removeClass('invalid'); // Remove invalid class if fixed
      }
    });

    return isValid;
  };

  // Handle click events on the progress bar
  DOMstrings.stepsBar.on('click', `.${DOMstrings.stepsBtnClass}`, function () {
    const activeStep = getActiveStep($(this));
    setActiveStep(activeStep);
    setActivePanel(activeStep);
  });

  // Handle click events for navigation buttons
  DOMstrings.stepsForm.on('click', `.${DOMstrings.stepPrevBtnClass}, .${DOMstrings.stepNextBtnClass}`, function () {
    const eventTarget = $(this);
    const activePanel = findParent(eventTarget, DOMstrings.stepFormPanelClass);
    let activePanelNum = DOMstrings.stepFormPanels.index(activePanel);

    if (eventTarget.hasClass(DOMstrings.stepPrevBtnClass)) {
      activePanelNum--; // Move to the previous panel
    } else {
      // Validate before moving to the next panel
      if (!validateCurrentPanel()) {
        // Show SweetAlert
        Swal.fire({
          title: 'Validation Error',
          text: 'Please fill in all required fields.',
          icon: 'warning',
          confirmButtonText: 'OK',
          background: '#fff5e6',
          showCloseButton: true,
          timer: 3000
        });
        return; // Stop further execution to prevent moving to the next step
      }
      activePanelNum++; // Move to the next panel only if validation passes
    }

    // Update the active step and panel
    setActiveStep(activePanelNum);
    setActivePanel(activePanelNum);
  });

  // Set form height on load and resize
  $(window).on('load resize', setFormHeight);
});